import { Jodit } from 'jodit-pro-react';

// Any colour unlikely to be picked; only lives for the moment between the two steps below
const STAND_IN_HEX = '#010203';
const STAND_IN_RGB = 'rgb(1, 2, 3)';

function isBlack(value: unknown): boolean {
  const color = String(value ?? '')
    .replace(/\s+/g, '')
    .toLowerCase();
  return ['#000', '#000000', 'black', 'rgb(0,0,0)', 'rgba(0,0,0,1)'].includes(color);
}

/**
 * Lets the text colour picker apply black.
 *
 * Before wrapping text in a colour, Jodit checks the colour that text would have on a blank page, and skips the change
 * when they match. Plain text on a blank page is black, so picking black did nothing whenever the text only inherited
 * its colour (e.g. white text in a proposal section): the selection stayed white.
 *
 * Here black is applied in two steps: Jodit applies a stand-in colour (wrapping the selection the normal way), then the
 * stand-in is switched to black and the editor value is synced.
 */
export function attachBlackForecolor(editor: Jodit) {
  editor.e.on('beforeCommand', (command: string, _showUI: unknown, value: unknown) => {
    if (command !== 'forecolor' || !isBlack(value)) return;

    try {
      editor.execCommand('forecolor', false, STAND_IN_HEX);
    } finally {
      // `finally`: an `afterCommand` handler that throws must not leave the stand-in colour in the text
      editor.editor.querySelectorAll<HTMLElement>('[style*="color"]').forEach(element => {
        if (element.style.color === STAND_IN_RGB) element.style.color = '#000000';
      });
      editor.synchronizeValues();
    }

    // Black is applied; skip Jodit's own run of the command
    return false;
  });
}
